<template>
  <div class="ej" v-if="false">
    <div class="ej-title">
      <div class="txt1">112人正在发起组团参观，可直接参与</div>
      <span class="txt3">查看更多</span>
    </div>
    <div class="ej-content">
      <Swipe class="my-swipe" :autoplay="300000" indicator-color="'#ddd'">
        <template v-for="(item,index) in list">
          <SwipeItem :key="index">
            <div class="brand-list">
              <div
                class="brand-list-one"
                v-for="(c,index) in item"
                :key="'c-'+index"
                @click="linkToInvite2(c.JoinId)"
              >
                <div class="one-img">
                  <img class="logo" :src="c.Logo" v-if="c.Logo" />
                  <img class="logo" src="@/assets/img/empty.png" v-if="!c.Logo" />
                  <div class="one-img-layout">
                    <div class="oil-bg"></div>
                    <div class="oil-l"><p>王涛发起的组团</p></div>
                    <img
                      src="https://img.zhanshangxiu.com/showonline/file/202007/1f061727a917488394536005638ac732.jpg"
                    />
                  </div>
                </div>
                <div class="one-info">
                  <div class="oi-title">
                    <span>2020/07/21</span>
                    <span>江苏·南京</span>
                  </div>
                  <div class="oi-info">玫莉蔻是专做玫瑰精油护肤的品牌，玫莉蔻是专做玫瑰精油护肤...</div>
                  <div class="oi-logo">
                    <div class="live-people">
                      <template v-for="(item,index) in exList.slice(0,3)">
                        <img
                          class="live-logo"
                          src="https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=1633190730,3574775808&fm=26&gp=0.jpg"
                          :key="index"
                          v-if="item.Logo"
                          v-load="'oAvatarSmall'"
                        />
                        <img class="live-logo" src="@/assets/img/empty.png" v-else :key="index" />
                      </template>
                      <div
                        class="live-count"
                        :class="viewerNum > 0 ?'':'live-count-none'"
                      >{{getCount(viewerNum)}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwipeItem>
        </template>
      </Swipe>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
export default {
  name: "ex-join",
  data() {
    return {
      viewerNum: 88,
      pageSize: 2,
      list: [],
      exList: [
        {
          Id: "f4e9df6c-4d41-4772-9061-01bc2d6c2e47",
          JoinId: "304fd75b-b8ca-4dd1-953c-dd5628b52e91",
          Logo:
            "https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/202005/295fcd0d0c5542ffa53ea35620819f54.jpg",
          CompName: "河北金成源纺织品有限公司",
          ShortName: "金成源纺织",
        },
        {
          Id: "e40d34e3-2773-4688-9531-9a28fc471302",
          JoinId: "14544f88-ceea-4bb2-a21e-9cf0d40b3ed0",
          Logo:
            "https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/202003/038e21d84db04219b38dac8eb1958542.jpg",
          CompName: "山东星宇手套有限公司",
          ShortName: "星宇",
        },
        {
          Id: "f4e9df6c-4d41-4772-9061-01bc2d6c2e47",
          JoinId: "304fd75b-b8ca-4dd1-953c-dd5628b52e91",
          Logo:
            "https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/202005/295fcd0d0c5542ffa53ea35620819f54.jpg",
          CompName: "河北金成源纺织品有限公司",
          ShortName: "金成源纺织",
        },
        {
          Id: "e40d34e3-2773-4688-9531-9a28fc471302",
          JoinId: "14544f88-ceea-4bb2-a21e-9cf0d40b3ed0",
          Logo:
            "https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/202003/038e21d84db04219b38dac8eb1958542.jpg",
          CompName: "山东星宇手套有限公司",
          ShortName: "星宇",
        },
        {
          Id: "f4e9df6c-4d41-4772-9061-01bc2d6c2e47",
          JoinId: "304fd75b-b8ca-4dd1-953c-dd5628b52e91",
          Logo:
            "https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/202005/295fcd0d0c5542ffa53ea35620819f54.jpg",
          CompName: "河北金成源纺织品有限公司",
          ShortName: "金成源纺织",
        },
        {
          Id: "e40d34e3-2773-4688-9531-9a28fc471302",
          JoinId: "14544f88-ceea-4bb2-a21e-9cf0d40b3ed0",
          Logo:
            "https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/202003/038e21d84db04219b38dac8eb1958542.jpg",
          CompName: "山东星宇手套有限公司",
          ShortName: "星宇",
        },
      ],
    };
  },
  components: {
    Swipe,
    SwipeItem,
  },
  created() {
    const ExArr = [];
    this.exList.forEach((e, i) => {
      const c = Math.floor(i / this.pageSize);
      if (!ExArr[c]) {
        ExArr[c] = [];
      }
      ExArr[c].push(e);
    });
    this.list = ExArr;
    // console.log("this.list:", this.list);
  },
  methods: {
    linkToInvite2() {},
    // 人数超过w换算
    getCount(param) {
      let count = 0;
      if (param > 10000) {
        count = (param / 10000).toFixed(1);
        if (String(count)[count.length - 1] == 0) {
          count = (count / 1).toFixed(0);
        }
        return count + "w";
      }
      return param;
    },
  },
};
</script>

<style lang="scss" scoped>
.ej {
  background: #fff;
  margin-bottom: 15px;
  &-title {
    padding: 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;

    .txt1 {
      font-size: 15px;
      color: #333;
      display: flex;
      align-items: baseline;
      flex: 1;
      font-weight: bold;
    }
    .txt3 {
      margin-left: 10px;
      font-size: 0.24rem;
      color: #666;
    }
  }
  &-content {
    padding: 0 13px 15px;
    background: #fff;
    .brand-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 2px 5px;
      &-one {
        width: calc(50% - 8px);
        background-color: #fff;
        margin-bottom: 15px;
        margin-top: 15px;
        box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.2);
        padding-bottom: 6px;
        border-radius: 5px;
        .one-img {
          height: 95px;
          position: relative;
          .logo {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            max-width: 90%;
            max-height: 90%;
            z-index: 1;
          }
          &-layout {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 0.5rem;
            padding: 0 0.15rem;
            z-index: 2;
            display: flex;
            align-items: center;
            img {
              width: 0.56rem;
              height:0.56rem;
              display: inline-block;
              border: 1px solid #fff;
              border-radius: 50%;
              position: relative;
              top: -0.11rem;
              
              z-index: 1;
            }
            .oil {
              &-l {
                line-height:initial;
                flex: 1;
                font-size: 0.24rem;
                font-weight: bold;
                color: #fff;
                position: relative;
                z-index: 4;
                height: 0.5rem;
                display: flex;
                align-items: center;
                text-align: left;
                max-width: calc(100% - 0.56rem) ;
                p{
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                // text-shadow: -1px 1px 2px rgba(0, 0, 0, 0.35);
              }
              &-bg {
                z-index: 3;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.3) 100%);;
                // background: url("../../../assets/img/new/bg-linear.png")
                //   no-repeat;
              }
            }
          }
        }
        .one-info {
          height: 95px;
          padding: 10px 8px;
          background-color: #fff;
          color: #333;
          border-radius: 0 0 5px 5px;
          line-height: 12px;
          text-align: left;
          .oi-title {
            font-size: 11px;
            color: #333;
            display: flex;
            margin-bottom: 8px;
            font-family: PingFang-SC-Medium;
            justify-content: space-between;
          }
          .oi-info {
            font-size: 10px;
            color: #666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 12px;
          }
        }
      }
    }
    .brand-list-3 {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 2px 5px;
      &-one {
        width: 30%;
        background-color: #fff;
        margin-bottom: 15px;
        .one-img {
          padding-top: 100%;
          width: 100%;
          position: relative;
          border: solid 1px #e6e6e6;
          box-sizing: content-box;
          border-radius: 3px;
          img {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            max-width: 90%;
            max-height: 90%;
          }
        }
        p {
          font-size: 14px;
          line-height: 2.2;
          color: #222;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }
      }
    }
  }
  &-item {
    display: inline-block;
    width: 95px;
    height: 126.5px;
    border-radius: 3px;
    border: solid 1px #e6e6e6;
    margin-right: 5px;
    position: relative;
  }
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
}
.my-swipe {
  ::v-deep {
    .van-swipe__indicators {
      bottom: 1px;
    }
    .van-swipe__indicator {
      background-color: #ddd;
    }
    .van-swipe__indicator--active {
      background-color: #fe781d;
    }
    .van-swipe__track {
      padding-bottom: 10px;
    }
  }
}
.live-people {
  min-width: 2rem;
  width: 20%;
  height: 0.46rem;
  display: flex;

  .live-logo {
    width: 0.46rem;
    height: 0.46rem;
    border-radius: 50%;
    display: block;
    border: 1px solid #fff;
  }

  .live-logo:nth-child(1) {
    z-index: 103;
    position: relative;
  }

  .live-logo:nth-child(2) {
    z-index: 102;
    position: relative;
    margin-left: -0.2rem;
  }

  .live-logo:nth-child(3) {
    z-index: 99;
    position: relative;
    margin-left: -0.2rem;
  }

  .live-count {
    min-width: 0.96rem;
    height: 0.46rem;
    color: #fff;
    font-size: 0.2rem;
    border-radius: 0.46rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 0.36rem;
    margin-left: -0.34rem;
    text-align: center;
    padding-right: 0.1rem;
    color: #666;
  }

  .live-count-none {
    margin: 0;
    padding: 0;
  }
}
</style>